import type { RouteObject } from 'react-router'

export type RouteGroup = 'client' | 'lp' | 'member'

// NOTE: パス接頭辞からルートグループを判定する。
// RouteErrorBoundary が「未マッチのパスが別グループのものか」を判定する際にも使う。
export const resolveRouteGroup = (pathname: string): RouteGroup => {
  if (pathname.startsWith('/client')) return 'client'
  if (pathname.startsWith('/lp')) return 'lp'

  return 'member'
}

// NOTE: パス接頭辞に基づいて該当グループのルート定義だけを動的 import する。
// client/member/lp のルート定義ファイルが他グループのバンドルに含まれないようにするため。
// NOTE: 判定はアプリ起動時の一度きりなので、どのグループを読み込んだかも併せて返す。
// RouteErrorBoundary が別グループへのクライアントサイド遷移を検知するのに使う。
const loadRouteGroup = async (): Promise<{ group: RouteGroup, routes: RouteObject[] }> => {
  const group = resolveRouteGroup(window.location.pathname)

  if (group === 'client') return { group, routes: (await import('./client')).default }
  if (group === 'lp') return { group, routes: (await import('./lp')).default }

  return { group, routes: (await import('./member')).default }
}

export default loadRouteGroup
